import { Node as PMNode } from '@tiptap/pm/model';
import {
  TEMPLATE_FIELD_INLINE_NAME,
  TEMPLATE_FIELD_BLOCK_NAME,
  TEMPLATE_FIELD_DROPDOWN_NAME,
} from '../doc-engine/templateFields';
import { TTemplateField } from '../types';

/**
 * Extract template field definitions from a document.
 * Used during template auto-save to populate draft.templateFields.
 *
 * Doc-based: save REPLACES draft.templateFields with this list, so the caller has to pass the WHOLE
 * document - which for a large one is more than the editor holds.
 */
export const extractTemplateFields = (doc: PMNode): TTemplateField[] => {
  const fields: TTemplateField[] = [];
  const schema = doc.type.schema;
  const inlineType = schema.nodes[TEMPLATE_FIELD_INLINE_NAME];
  const blockType = schema.nodes[TEMPLATE_FIELD_BLOCK_NAME];
  const dropdownType = schema.nodes[TEMPLATE_FIELD_DROPDOWN_NAME];

  doc.descendants((node) => {
    if (node.type === dropdownType) {
      const fieldId = node.attrs.fieldId;
      if (!fieldId) {
        console.warn('[extractTemplateFields] Dropdown field node found without fieldId, skipping');
        return false;
      }
      fields.push({
        fieldId,
        type: 'DROPDOWN',
        active: true,
        // options are NOT included here - they are merged from templateDropdownOptionsRef during save.
      });
      return false;
    }
    if (node.type === inlineType || node.type === blockType) {
      const fieldId = node.attrs.fieldId;
      if (!fieldId) {
        console.warn('[extractTemplateFields] Field node found without fieldId, skipping');
        return false;
      }
      fields.push({
        fieldId,
        type: node.type === inlineType ? 'INLINE' : 'BLOCK',
        active: true,
      });
      return false;
    }
    return true;
  });

  return fields;
};
